export const BASE_URL = "https://www.vidyalayalms.com";

export const SuccessNumbers = {
    Years : 23,
    SatisfiedClients : 1800,
    ClientRetention : 96,
    Modules : 40,
    VerifiedReviews: 2500,
    ProfessionalsTrained: 25000,
    Student: '1.5 Millions',
    ITProfessional : 200
}
export const Contact_Email = "sales.vidyalaya@sapphiresolutions.net";
export const Contact_Num_Sales1 = "+91-942-644-2424";
export const Contact_Num_Sales2 = "+91-972-674-8800";
export const Contact_Num_Sales3 = "9512304599";
